// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ds5l","content":"styles_content__rEM-b","footText":"styles_footText__1kwyl"};